// $( document ).ready(function() {
//     $( "a" ).each(function() {
//         let getURL = $( this ).attr( "href" );

//         if (getURL.match('/product')) {
//            // console.log(getURL);
//         } else {
//             $(this).attr('target', '_blank');
//         }

//       });
// });


// $( document ).ready(function() {
//     $( ".footer__menu-title" ).each(function() {
//       let getText = $(this).text();
//         if (getText == 'Associated Sites') {
//             let getLinks = $(this).siblings('.footer__links').find('a');

//             getLinks.attr('target', '_blank');
//         }
       


//       });
// });

if (window.location.pathname.includes('free-gift')) {
  window.location.href = '/';
}